import { useMsal } from '@azure/msal-react';
import { LoginContext } from '@synqo/frontend-component-library';
import { useCallback, useContext } from 'react';
import { type LoginRequest } from './acquireToken';

// @ai-generated 2026-10-29T10:48:14+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** Starts the interactive sign-in redirect and tells the frontend library that a login began. */
export const useLogin = (loginRequest: LoginRequest) => {
    const { instance } = useMsal();
    const { doLogin } = useContext(LoginContext);

    return useCallback(async () => {
        doLogin();
        await instance.loginRedirect({ ...loginRequest });
    }, [doLogin, instance, loginRequest]);
};

// @ai-generated 2026-10-29T10:48:14+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
/** Signs the active account out through a redirect and tells the frontend library that a logout began. */
export const useLogout = () => {
    const { instance } = useMsal();
    const { doLogout } = useContext(LoginContext);

    return useCallback(async () => {
        const activeAccount = instance.getActiveAccount();
        doLogout();
        await instance.logoutRedirect({ account: activeAccount });
    }, [doLogout, instance]);
};
